import React, { useEffect, useState, useMemo, useCallback, useRef } from "react";
import _ from "lodash";
// @material-ui/core components
import {
  Box,
  Button,
  Collapse,
  IconButton,
  InputAdornment,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TablePagination,
  TableRow,
} from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";
import moment from "moment";
// core components
import GridItem from "../../components/Grid/GridItem.js";
import GridContainer from "../../components/Grid/GridContainer.js";
// import Table from "../../components/Table/Table.js";
import AddIcon from "@material-ui/icons/Add";
import VisibilityIcon from "@material-ui/icons/Visibility";
import DeleteIcon from "@material-ui/icons/Delete";
import OrderView from "../Order/OrderView";
import axios from "axios";
import PrintIcon from "@mui/icons-material/Print";
import {
  BulkPrintOrdersAPI,
  DeleteOrderAPI,
  GetAllOrdersAPI,
  UpdateMultipleOrders,
  UpdateOrderAPI,
} from "../../config/api";
import { ConfirmationDialog } from "../../components/common";
import CustomTabs from "../../components/CustomTabs/CustomTabs";
import Code from "@material-ui/icons/Code";
import Cloud from "@material-ui/icons/Cloud";
import Checkbox from "@material-ui/core/Checkbox";
import { useHistory } from "react-router-dom";
import People from "@material-ui/icons/People";
import CustomInput from "../../components/CustomInput/CustomInput";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { OrderDetailsDialog } from "../OrderApp/OrderDetailsDialog.js";
import CompanyOrderView from "../OrderApp/CompanyOrderView.js";
import { useSelector } from "react-redux";
import FittingOrderAdd from "../Order/FittingOrderAdd.js";
import { toast } from "react-toastify";
import { readyOrderTemplate } from "../../assets/html/readyOrderTemplate.js";
import { dataURItoBlob, htmlTemplateToDataString } from "../../utils/index.js";
import { Search } from "@material-ui/icons";
const useStyles = makeStyles((theme) => ({
  fab: {
    position: "absolute",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
}));

const columns = [
  { id: "party", label: "Party" },
  { id: "code", label: "Order Code" },
  { id: "orderType", label: "Order Type" },
  { id: "productNameR", label: "Product Name R" },
  { id: "productNameL", label: "Product Name L" },
  // { id: "productType", label: "Product Type" },
  {
    id: "orderAmount",
    label: "Order Amount",
    format: (value) =>
      Number(value).toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      }),
  },
  {
    id: "createdAt",
    label: "Order Date",
    format: (value) => (value ? moment(value).format("DD-MM-YYYY") : ""),
  },
  { id: "action", label: "Action" },
  { id: "collapse" },
];

const itemColumns = [
  { id: "nameR", label: "Name R" },
  { id: "nameL", label: "Name L" },
  { id: "quantity", label: "Quantity" },
  {
    id: "amount",
    label: "Amount",
    format: (value) =>
      Number(value).toLocaleString("en-IN", {
        maximumFractionDigits: 2,
        style: "currency",
        currency: "INR",
      }),
  },
];

const columnsCompany = [
  { id: "party", label: "Party" },
  // { id: "orderType", label: "Order Type" },
  { id: "totalOrders", label: "Total Orders" },
  { id: "totalAmt", label: "Total Amount" },
  { id: "totalQty", label: "Total Quantity" },

  {
    id: "date",
    label: "Order Date",
    format: (value) => (value ? moment(value).format("DD-MM-YYYY") : ""),
  },
  { id: "action", label: "Action" },
];

export default function ReadyOrderList(props) {
  const classes = useStyles();
  const history = useHistory();

  const [orders, setOrders] = useState([]);
  const [openFittingOrderAddDialog, setOpenFittingOrderAddDialog] =
    useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedRows1, setSelectedRows1] = useState([]);

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openViewDialog, setOpenViewDialog] = useState(null);
  const [openViewCompanyOrderDialog, setOpenViewCompanyOrderDialog] =
    useState(null);

  const [openConfirmationModal, setOpenConfirmationModal] = useState(null);
  const [openOrderDetailsModal, setOpenOrderDetailsModal] = useState(null);
  const [orderAdminDetails, setOrderAdminDetails] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [search, setSearch] = useState("");
  const userInfo = useSelector((state) => state.userReducer.userInfo);
  const authToken = useSelector((state) => state.userReducer.authToken);

  const _getOrders = useCallback(async (page, rowsPerPage) => {
    try {
      let res = await axios.get(
        GetAllOrdersAPI(userInfo.entity) +
        `&sortBy=createdAt:desc&orderReturnStatus=None&limit=${rowsPerPage}&skip=${page * rowsPerPage
        }`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setOrders(res.data.orders);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error fetching orders:", err);
      }
      toast.error("Failed to fetch orders. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [userInfo.entity, authToken]);

  const searchData = useCallback(async (term) => {
    if (!term || term.trim() === "") {
      _getOrders(page, rowsPerPage);
      return;
    }
    try {
      setSearchTerm(term);
      let res = await axios.get(
        GetAllOrdersAPI(userInfo.entity) +
        `&sortBy=createdAt:desc&orderReturnStatus=None&limit=${rowsPerPage}&skip=${page * rowsPerPage
        }&code=${term}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      setOrders(res.data.orders);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error searching orders:", err);
      }
      toast.error("Failed to search orders. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [userInfo.entity, authToken, page, rowsPerPage, _getOrders]);

  // Debounced search function
  const debouncedSearchRef = useRef(
    _.debounce((term, searchFn) => {
      searchFn(term);
    }, 300)
  );

  // Cleanup debounced function on unmount
  useEffect(() => {
    return () => {
      debouncedSearchRef.current.cancel();
    };
  }, []);

  useEffect(() => {
    _getOrders(page, rowsPerPage);
  }, [openViewCompanyOrderDialog, page, rowsPerPage, _getOrders]);

  //print ready order
  const handlePrint = useCallback(async (row) => {
    let options = {
      orientation: "p",
      unit: "pt",
      format: [284, 300],
      putOnlyUsedFonts: true,
    };
    let htmlTemplate = readyOrderTemplate(row);
    await htmlTemplateToDataString(htmlTemplate, options, (dataString) => {
      const preBlob = dataURItoBlob(dataString);
      const blobUrl = URL.createObjectURL(preBlob);
      const printWindow = window.open(blobUrl, "_blank");

      // Cleanup blob URL to prevent memory leaks
      if (printWindow) {
        printWindow.addEventListener('beforeunload', () => {
          URL.revokeObjectURL(blobUrl);
        });
      } else {
        // If popup blocked, cleanup after timeout
        setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
      }
    });
  }, []);

  const handlePrints = useCallback(async (rows, data) => {
    // Render each order individually onto its own PDF page to guarantee page breaks
    const ordersArray = Array.isArray(rows) ? rows : [rows];
    if (ordersArray.length === 0) return;

    const { default: jsPDF } = await import("jspdf");
    const { default: html2canvas } = await import("html2canvas");
    const pageWidth = 284;
    const pageHeight = 300;
    const renderWidthPx = 284;

    const pdf = new jsPDF({ orientation: "p", unit: "pt", format: [pageWidth, pageHeight] });

    for (let i = 0; i < ordersArray.length; i++) {
      const htmlTemplate = readyOrderTemplate(ordersArray[i]);

      const iframe = document.createElement("iframe");
      iframe.style.position = "fixed";
      iframe.style.left = "-10000px";
      iframe.style.top = "0";
      iframe.style.width = `${renderWidthPx}px`;
      iframe.style.height = "1px";
      iframe.style.visibility = "hidden";
      iframe.style.border = "0";
      document.body.appendChild(iframe);

      const doc = iframe.contentDocument || iframe.contentWindow?.document;
      doc.open();
      doc.write(htmlTemplate);
      doc.close();

      await new Promise((r) => requestAnimationFrame(() => r()));
      await new Promise((r) => requestAnimationFrame(() => r()));

      const target = doc.body;
      const canvas = await html2canvas(target, {
        scale: 1,
        useCORS: true,
        logging: false,
        allowTaint: true,
        imageTimeout: 0,
        backgroundColor: "#ffffff",
        width: renderWidthPx,
      });

      document.body.removeChild(iframe);

      if (i > 0) {
        pdf.addPage([pageWidth, pageHeight]);
      }

      const imgData = canvas.toDataURL("image/jpeg", 0.92);
      const ratio = pageWidth / (canvas.width || renderWidthPx);
      const imgHeight = Math.min((canvas.height || 0) * ratio, pageHeight);
      pdf.addImage(imgData, "JPEG", 0, 0, pageWidth, imgHeight);
    }

    const dataString = pdf.output("datauristring");
    const preBlob = dataURItoBlob(dataString);
    const blobUrl = URL.createObjectURL(preBlob);
    const printWindow = window.open(blobUrl, "_blank");

    if (printWindow) {
      printWindow.addEventListener('beforeunload', () => {
        URL.revokeObjectURL(blobUrl);
      });
    } else {
      setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
    }
  }, []);

  const _deleteItem = useCallback(async (item) => {
    try {
      await axios.delete(DeleteOrderAPI(item._id), {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      toast.success("Order deleted successfully!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      _getOrders(page, rowsPerPage);
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error deleting order:", e);
      }
      toast.error("Failed to delete order. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [authToken, _getOrders, page, rowsPerPage]);

  const _onPrintAllOrders = useCallback(async () => {
    try {
      await axios.post(
        BulkPrintOrdersAPI(),
        {
          orders: selectedRows,
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      let tmp = [];
      selectedRows.forEach((i) => {
        let o = _.find(orders, { _id: i });
        if (o) tmp.push(o);
      });
      history.push("/admin/order-print", { orders: tmp });
    } catch (e) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error printing orders:", e);
      }
      toast.error("Failed to print orders. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [selectedRows, orders, authToken, history]);

  const _confirmOrder = useCallback(async (row, data) => {
    try {
      await axios.patch(
        UpdateOrderAPI(row.code),
        {
          orderCompleted: true,
          orderStatus: "Completed",
          orderAdminStatus: "Confirmed",
          orderAdminDetails: [...row.orderAdminDetails, data],
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      toast.success("Order confirmed successfully!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      _getOrders(page, rowsPerPage);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error confirming order:", err);
      }
      toast.error("Failed to confirm order. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [authToken, _getOrders, page, rowsPerPage]);

  const _confirmMultipleOrders = useCallback(async (selectedRows1, data) => {
    try {
      const apiURL = UpdateMultipleOrders();

      // Create an array of updates for each selected order
      const updates = selectedRows1.map((row) => ({
        code: row.code,
        orderAdminStatus: "Confirmed",
        orderStatus: "Completed",
        orderCompleted: true,
        orderAdminDetails: [...row.orderAdminDetails, data],
      }));

      // Make the API request to update multiple orders
      let res = await axios.patch(
        apiURL,
        { selectedRows: updates },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      _getOrders(page, rowsPerPage);
      setSelectedRows1([]);
      if (res.status === 200) {
        toast.success("Records updated successfully!", {
          position: "top-center",
          autoClose: 1500,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      }
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error updating records:", err);
      }
      toast.error("Failed to update records. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [authToken, _getOrders, page, rowsPerPage]);

  const _rejectOrder = useCallback(async (row, data) => {
    try {
      await axios.patch(
        UpdateOrderAPI(row.code),
        {
          orderAdminStatus: "Rejected",
          orderAdminDetails: [...row.orderAdminDetails, data],
        },
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      toast.success("Order rejected successfully!", {
        position: "top-center",
        autoClose: 1500,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      _getOrders(page, rowsPerPage);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error("Error rejecting order:", err);
      }
      toast.error("Failed to reject order. Please try again.", {
        position: "top-center",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
    }
  }, [authToken, _getOrders, page, rowsPerPage]);

  const handleOpenConfirmationModal = useCallback((object) => {
    setOpenConfirmationModal(object);
  }, []);

  const handleCloseConfirmationModal = useCallback(() => {
    setOpenConfirmationModal(null);
  }, []);

  const handleOpenOrderDetailsModal = useCallback((object) => {
    setOpenOrderDetailsModal(object);
  }, []);

  const handleCloseOrderDetailsModal = useCallback(() => {
    setOpenOrderDetailsModal(null);
  }, []);

  const handleChangePage = useCallback((event, newPage) => {
    setPage(newPage);
  }, []);

  const handleChangeRowsPerPage = useCallback((event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  }, []);

  const closeFittingOrderAddDialog = useCallback(() => {
    setOpenFittingOrderAddDialog(false);
  }, []);

  const closeViewDialog = useCallback(() => {
    setOpenViewDialog(null);
  }, []);

  const closeViewCompanyOrderDialog = useCallback(() => {
    setOpenViewCompanyOrderDialog(null);
  }, []);

  const handleSearch = useCallback(() => {
    if (search.trim() === "") {
      _getOrders(page, rowsPerPage);
      setSearchTerm("");
    } else {
      debouncedSearchRef.current(search, searchData);
    }
  }, [search, _getOrders, page, rowsPerPage, searchData]);

  const RenderOrderTableRow = ({ row, orderType }) => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const detail = row.orderDetail || {};
    const items =
      row.items && Array.isArray(row.items) && row.items.length > 0
        ? row.items.map((it) => ({
            nameR: it.productNameR || it.nameR || it.rLens || "",
            nameL: it.productNameL || it.nameL || it.lLens || "",
            quantity: it.quantity != null ? it.quantity : 1,
            amount: it.amount ?? it.orderAmount ?? 0,
          }))
        : [
            {
              nameR: detail.productNameR || detail.rLens || "",
              nameL: detail.productNameL || detail.lLens || "",
              quantity: row.quantity != null ? row.quantity : 1,
              amount: row.orderAmount ?? row.price ?? 0,
            },
          ];

    return (
      <React.Fragment>
        <TableRow hover role="checkbox" tabIndex={-1}>
          {orderType === "Prescription" ? (
            <TableCell padding="checkbox">
              <Checkbox
                style={{ color: "#512da8" }}
                onChange={() => {
                  let copy = _.clone(selectedRows);
                  if (_.includes(copy, row._id)) {
                    const idx = _.indexOf(copy, row._id);
                    copy.splice(idx, 1);
                  } else {
                    copy.push(row._id);
                  }
                  setSelectedRows(copy);
                  let rows = _.clone(selectedRows1);
                  const idx = _.findIndex(rows, (r) => r._id === row._id);
                  if (idx !== -1) rows.splice(idx, 1);
                  else rows.push(row);
                  setSelectedRows1(rows);
                }}
                checked={_.includes(selectedRows, row._id)}
                inputProps={{ "aria-labelledby": row._id }}
              />
            </TableCell>
          ) : null}
          {columns.map((column) => {
            let value = row[column.id];
            if (column.id === "collapse") {
              return (
                <TableCell key={column.id} align="center">
                  <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={() => setIsCollapsed(!isCollapsed)}
                  >
                    {isCollapsed ? (
                      <KeyboardArrowUpIcon />
                    ) : (
                      <KeyboardArrowDownIcon />
                    )}
                  </IconButton>
                </TableCell>
              );
            }
            if (column.id === "product") {
              if (row.orderType === "Fitting") {
                value =
                  row.orderDetail?.productName != null
                    ? row.orderDetail.productName
                    : "";
              } else if (row.orderType === "Ready") {
                value =
                  row.orderDetail?.product?.name != null
                    ? row.orderDetail.product.name
                    : "";
              } else {
                value =
                  row.orderDetail?.product?.productName != null
                    ? row.orderDetail.product.productName
                    : "";
              }
            }
            if (column.id === "productNameL") {
              value =
                row.orderDetail?.side === "L"
                  ? row.orderDetail?.productName
                  : row.orderDetail?.lLens;
            }
            if (column.id === "productNameR") {
              value =
                row.orderDetail?.side === "R"
                  ? row.orderDetail?.productName
                  : row.orderDetail?.rLens;
            }
            if (column.id === "action") {
              return (
                <TableCell key={column.id} align="center">
                  <Box display="flex" justifyContent="center">
                    <IconButton
                      aria-label="view"
                      onClick={() =>
                        setOpenViewDialog({ open: true, item: row })
                      }
                    >
                      <VisibilityIcon />
                    </IconButton>
                    <IconButton aria-label="print" onClick={() => handlePrint(row)}>
                      <PrintIcon />
                    </IconButton>
                    {row.orderAdminStatus === "Pending" && (
                      <>
                        <IconButton
                          aria-label="confirm"
                          onClick={() =>
                            handleOpenOrderDetailsModal({
                              title: "Do you want to Accept Order",
                              onPress: (data) => _confirmOrder(row, data),
                            })
                          }
                        >
                          <CheckCircleIcon />
                        </IconButton>
                        <IconButton
                          aria-label="reject"
                          onClick={() =>
                            handleOpenOrderDetailsModal({
                              title: "Do you want to Reject Order",
                              onPress: (data) => _rejectOrder(row, data),
                            })
                          }
                        >
                          <CancelIcon />
                        </IconButton>
                      </>
                    )}
                    <IconButton
                      aria-label="delete"
                      onClick={() =>
                        handleOpenConfirmationModal({
                          msg: "Do you want to delete this record?",
                          title: "Delete Record",
                          onPress: () => _deleteItem(row),
                        })
                      }
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Box>
                </TableCell>
              );
            }
            if (column.id === "party") {
              return (
                <TableCell key={column.id} align="center">
                  {value?.accountName}
                </TableCell>
              );
            }
            return (
              <TableCell key={column.id} align="center">
                {column.format ? column.format(value) : value}
              </TableCell>
            );
          })}
        </TableRow>
        <TableRow>
          <TableCell
            style={{ paddingBottom: 0, paddingTop: 0 }}
            colSpan={
              columns.length + (orderType === "Prescription" ? 1 : 0)
            }
          >
            <Collapse in={isCollapsed} timeout="auto" unmountOnExit>
              <Table size="small" aria-label="order details">
                <TableHead>
                  <TableRow>
                    {itemColumns.map((col) => (
                      <TableCell
                        key={col.id}
                        align="center"
                        style={{ minWidth: col.minWidth }}
                      >
                        {col.label}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.map((itemRow, index) => (
                    <TableRow key={index} hover>
                      {itemColumns.map((col) => {
                        const val = itemRow[col.id];
                        return (
                          <TableCell key={col.id} align="center">
                            {col.format
                              ? col.format(val)
                              : val}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  };

  const _renderTable = useCallback((orderType, data) => {
    return (
      <GridItem xs={12} sm={12} md={12}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          {/* {orderType === "Prescription" ? (
            <Button
              color="primary"
              onClick={() =>
                handleOpenConfirmationModal({
                  msg: "Do you want to print all records",
                  onPress: () => _onPrintAllOrders(),
                })
              }
            >
              Print All Records
            </Button>
          ) : (
            <div />
          )} */}
          <div>
            <CustomInput
              id="search"
              formControlProps={{
                fullWidth: false,
              }}
              inputProps={{
                style: {
                  color: "primary",
                  marginTop: 0,
                },
                placeholder: "Search by code....",
                value: search,
                // onChange: (e) => searchData(e.target.value),
                // onSubmit: (e) => searchData(e.target.value),
                onChange: (e) => {
                  const value = e.target.value;
                  setSearch(value);
                  if (value === "" || value === null) {
                    debouncedSearchRef.current.cancel();
                    _getOrders(page, rowsPerPage);
                    setSearchTerm("");
                  }
                },
                // onChange: (e) => handleInputChange(e),
                onKeyDown: (e) => {
                  if (e.keyCode === 13) {
                    e.preventDefault();
                    handleSearch();
                  }
                },
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      color={"primary"}
                      onClick={(e) => {
                        // setSearchTerm(e.target.value),
                        // handleKeyPress(e)
                        // handleKeyPress()
                        handleSearch();
                      }}
                    >
                      <Search />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <IconButton
              aria-label="add"
              onClick={() => setOpenFittingOrderAddDialog(true)}
            >
              <AddIcon />
            </IconButton>
          </div>
        </Box>

        <Box>
          <div>
            {/* Conditionally render the Confirm button when selectedRows1 is not empty */}
            {selectedRows1.length > 0 && (
              <>
                <Button
                  color="Primary"
                  onClick={() =>
                    handleOpenOrderDetailsModal({
                      title: "Do you want to Accept Multiple Orders?",
                      onPress: (data) =>
                        _confirmMultipleOrders(selectedRows1, data),
                    })
                  }
                >
                  Confirm Selected Orders
                </Button>

                {/* Add the new Print Selected Orders button */}
                <Button
                  color="primary"
                  onClick={() =>
                    handleOpenOrderDetailsModal({
                      title: "Do you want to Print Multiple Orders?",
                      onPress: (data) =>
                        handlePrints(selectedRows1, data),
                    })
                  }
                >
                  Print Selected Orders
                </Button>
              </>
            )}

            {/* Display selected rows for debugging */}
            <div>
              <h4>Selected Rows: {selectedRows1.length}</h4>
            </div>
          </div>
        </Box>

        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {orderType === "Prescription" ? (
                <Checkbox
                  style={{
                    color: "#512da8",
                  }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      const c = orders.map((i) => i._id);
                      const d = [...data];
                      setSelectedRows(c);
                      setSelectedRows1(d);
                    } else {
                      setSelectedRows([]);
                      setSelectedRows1([]);
                    }
                  }}
                  checked={
                    selectedRows.length > 0 &&
                    orders.length === selectedRows.length
                  }
                  inputProps={{ "aria-labelledby": -1 }}
                />
              ) : null}
              {columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={"center"}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => (
                <RenderOrderTableRow
                  key={row._id || row.code}
                  row={row}
                  orderType={orderType}
                />
              ))}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </GridItem>
    );
  }, [
    search,
    selectedRows1,
    orders,
    selectedRows,
    page,
    rowsPerPage,
    handleSearch,
    handleOpenOrderDetailsModal,
    handlePrints,
    _confirmMultipleOrders,
    handlePrint,
    handleOpenConfirmationModal,
    _deleteItem,
    _confirmOrder,
    _rejectOrder,
    handleChangePage,
    handleChangeRowsPerPage,
    setSearch,
    _getOrders,
    setSelectedRows,
    setSelectedRows1,
  ]);

  const _renderTableCompany = useCallback((orderType, data) => {
    if (searchTerm !== "") {
      data = _.filter(data, (i) => {
        return (
          i.code && i.code.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    }
    if (orderType === "Prescription") {
      data = _.orderBy(data, ["createdAt"], ["desc"]);
    }
    return (
      <GridItem xs={12} sm={12} md={12}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          {/* {orderType === "Prescription" ? (
            <Button
              color="primary"
              onClick={() =>
                handleOpenConfirmationModal({
                  msg: "Do you want to print all records",
                  onPress: () => _onPrintAllOrders(),
                })
              }
            >
              Print All Records
            </Button>
          ) : (
            <div />
          )} */}
          <div>
            <CustomInput
              id="search"
              formControlProps={{
                fullWidth: false,
              }}
              inputProps={{
                style: {
                  color: "primary",
                  marginTop: 0,
                },
                placeholder: "Search",
                value: searchTerm,
                onChange: (e) => setSearchTerm(e.target.value),
                endAdornment: (
                  <InputAdornment position="end">
                    <People />
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </Box>

        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {orderType === "Prescription" ? (
                <Checkbox
                  style={{
                    color: "#512da8",
                  }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      const c = orders.map((i) => i._id);
                      setSelectedRows(c);
                    } else {
                      setSelectedRows([]);
                    }
                  }}
                  checked={
                    selectedRows.length > 0 &&
                    orders.length === selectedRows.length
                  }
                  inputProps={{ "aria-labelledby": -1 }}
                />
              ) : null}
              {columnsCompany.map((column) => (
                <TableCell
                  key={column.id}
                  align={"center"}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {orderType === "Prescription" ? (
                      <TableCell padding="checkbox">
                        <Checkbox
                          style={{
                            color: "#512da8",
                          }}
                          onChange={() => {
                            let copy = _.clone(selectedRows);
                            if (_.includes(copy, row._id)) {
                              let index = _.indexOf(copy, row._id);
                              copy.splice(index, 1);
                            } else {
                              copy.push(row._id);
                            }
                            setSelectedRows(copy);
                          }}
                          checked={_.includes(selectedRows, row._id)}
                          inputProps={{ "aria-labelledby": row._id }}
                        />
                      </TableCell>
                    ) : null}
                    {columnsCompany.map((column) => {
                      let value = row[column.id];

                      if (column.id === "action") {
                        return (
                          <TableCell align={"center"}>
                            <Box display={"flex"} justifyContent={"center"}>
                              <IconButton
                                aria-label="view"
                                onClick={() =>
                                  setOpenViewCompanyOrderDialog({
                                    open: true,
                                    item: row,
                                  })
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              {row.orderAdminStatus === "Pending" && (
                                <React.Fragment>
                                  <IconButton
                                    aria-label="confirm"
                                    onClick={() =>
                                      handleOpenOrderDetailsModal({
                                        title: "Do you want to Accept Order",
                                        onPress: (data) =>
                                          _confirmOrder(row, data),
                                      })
                                    }
                                  >
                                    <CheckCircleIcon />
                                  </IconButton>
                                  <IconButton
                                    aria-label="reject"
                                    onClick={() =>
                                      handleOpenOrderDetailsModal({
                                        title: "Do you want to Reject Order",
                                        onPress: (data) =>
                                          _rejectOrder(row, data),
                                      })
                                    }
                                  >
                                    <CancelIcon />
                                  </IconButton>
                                </React.Fragment>
                              )}
                            </Box>
                          </TableCell>
                        );
                      }

                      if (column.id === "totalOrders") {
                        return (
                          <TableCell key={column.id} align={"center"}>
                            {row.orders.length}
                          </TableCell>
                        );
                      }

                      return (
                        <TableCell key={column.id} align={"center"}>
                          {column.format ? column.format(value) : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </GridItem>
    );
  }, [
    searchTerm,
    orders,
    selectedRows,
    page,
    rowsPerPage,
    handleOpenOrderDetailsModal,
    _confirmOrder,
    _rejectOrder,
    handleChangePage,
    handleChangeRowsPerPage,
    setSelectedRows,
    closeViewCompanyOrderDialog,
  ]);

  const _renderTableOrderInstance = useCallback((orderType, data) => {
    if (searchTerm !== "") {
      data = _.filter(data, (i) => {
        return (
          i.code && i.code.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
    }
    if (orderType === "Prescription") {
      data = _.orderBy(data, ["createdAt"], ["desc"]);
    }
    return (
      <GridItem xs={12} sm={12} md={12}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          {/* {orderType === "Prescription" ? (
            <Button
              color="primary"
              onClick={() =>
                handleOpenConfirmationModal({
                  msg: "Do you want to print all records",
                  onPress: () => _onPrintAllOrders(),
                })
              }
            >
              Print All Records
            </Button>
          ) : (
            <div />
          )} */}
          <div>
            <CustomInput
              id="search"
              formControlProps={{
                fullWidth: false,
              }}
              inputProps={{
                style: {
                  color: "primary",
                  marginTop: 0,
                },
                placeholder: "Search",
                value: searchTerm,
                onChange: (e) => setSearchTerm(e.target.value),
                endAdornment: (
                  <InputAdornment position="end">
                    <People />
                  </InputAdornment>
                ),
              }}
            />
          </div>
        </Box>

        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {orderType === "Prescription" ? (
                <Checkbox
                  style={{
                    color: "#512da8",
                  }}
                  onChange={(e) => {
                    if (e.target.checked) {
                      const c = orders.map((i) => i._id);
                      setSelectedRows(c);
                    } else {
                      setSelectedRows([]);
                    }
                  }}
                  checked={
                    selectedRows.length > 0 &&
                    orders.length === selectedRows.length
                  }
                  inputProps={{ "aria-labelledby": -1 }}
                />
              ) : null}
              {columnsCompany.map((column) => (
                <TableCell
                  key={column.id}
                  align={"center"}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                return (
                  <TableRow hover role="checkbox" tabIndex={-1} key={row.code}>
                    {orderType === "Prescription" ? (
                      <TableCell padding="checkbox">
                        <Checkbox
                          style={{
                            color: "#512da8",
                          }}
                          onChange={() => {
                            let copy = _.clone(selectedRows);
                            if (_.includes(copy, row._id)) {
                              let index = _.indexOf(copy, row._id);
                              copy.splice(index, 1);
                            } else {
                              copy.push(row._id);
                            }
                            setSelectedRows(copy);
                          }}
                          checked={_.includes(selectedRows, row._id)}
                          inputProps={{ "aria-labelledby": row._id }}
                        />
                      </TableCell>
                    ) : null}
                    {columnsCompany.map((column) => {
                      let value = row[column.id];

                      if (column.id === "action") {
                        return (
                          <TableCell align={"center"}>
                            <Box display={"flex"} justifyContent={"center"}>
                              <IconButton
                                aria-label="view"
                                onClick={() =>
                                  setOpenViewCompanyOrderDialog({
                                    open: true,
                                    item: row,
                                  })
                                }
                              >
                                <VisibilityIcon />
                              </IconButton>
                              {row.orderAdminStatus === "Pending" && (
                                <React.Fragment>
                                  <IconButton
                                    aria-label="confirm"
                                    onClick={() =>
                                      handleOpenOrderDetailsModal({
                                        title: "Do you want to Accept Order",
                                        onPress: (data) =>
                                          _confirmOrder(row, data),
                                      })
                                    }
                                  // onClick={(data) => _confirmOrder(row, data)}
                                  >
                                    <CheckCircleIcon />
                                  </IconButton>
                                  <IconButton
                                    aria-label="reject"
                                    onClick={() =>
                                      handleOpenOrderDetailsModal({
                                        title: "Do you want to Reject Order",
                                        onPress: (data) =>
                                          _rejectOrder(row, data),
                                      })
                                    }
                                  >
                                    <CancelIcon />
                                  </IconButton>
                                </React.Fragment>
                              )}
                            </Box>
                          </TableCell>
                        );
                      }

                      if (column.id === "party") {
                        return (
                          <TableCell key={column.id} align={"center"}>
                            {value.accountName}
                          </TableCell>
                        );
                      }

                      if (column.id === "totalOrders") {
                        return (
                          <TableCell key={column.id} align={"center"}>
                            {row.orders.length}
                          </TableCell>
                        );
                      }
                      return (
                        <TableCell key={column.id} align={"center"}>
                          {column.format ? column.format(value) : value}
                        </TableCell>
                      );
                    })}
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </GridItem>
    );
  }, [
    searchTerm,
    orders,
    selectedRows,
    page,
    rowsPerPage,
    handleOpenOrderDetailsModal,
    _confirmOrder,
    _rejectOrder,
    handleChangePage,
    handleChangeRowsPerPage,
    setSelectedRows,
    closeViewCompanyOrderDialog,
  ]);

  // Memoize expensive computations to prevent recalculation on every render
  const filteredOrders = useMemo(() => {
    return {
      companyPrescriptionOrders: _.chain(orders)
        .filter((order) => order.orderAdminStatus === "Pending")
        .groupBy("party.accountCode")
        .map((value, key) => ({ party: key, orders: value }))
        .value(),
      pendingPrescriptionOrders: _.filter(orders, {
        orderType: "Fitting",
        orderAdminStatus: "Pending",
        isOrderFromApp: false,
      }),
      completedFittingOrders: _.filter(orders, {
        orderType: "Fitting",
        isOrderFromApp: false,
        orderAdminStatus: "Confirmed",
      }),
      pendingFittingOrdersApp: _.filter(orders, {
        orderType: "Fitting",
        orderAdminStatus: "Pending",
        isOrderFromApp: true,
      }),
      completedFittingOrdersApp: _.filter(orders, {
        orderType: "Fitting",
        orderAdminStatus: "Confirmed",
        isOrderFromApp: true,
      }),
    };
  }, [orders]);

  const {
    companyPrescriptionOrders,
    pendingPrescriptionOrders,
    completedFittingOrders,
    pendingFittingOrdersApp,
    completedFittingOrdersApp,
  } = filteredOrders;

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CustomTabs
          title=""
          headerColor="primary"
          tabs={[
            {
              tabName: "Pending Web",
              tabIcon: Code,
              tabContent: _renderTable(
                "Prescription",
                pendingPrescriptionOrders
              ),
            },
            {
              tabName: "Confirmed Web",
              tabIcon: Cloud,
              tabContent: _renderTable("Fitting", completedFittingOrders),
            },
            {
              tabName: "Pending App",
              tabIcon: Code,
              tabContent: _renderTable("Prescription", pendingFittingOrdersApp),
            },
            {
              tabName: "Confirmed App",
              tabIcon: Cloud,
              tabContent: _renderTable(
                "Prescription",
                completedFittingOrdersApp
              ),
            },
          ]}
        />
      </GridItem>
      <FittingOrderAdd
        fetchData={_getOrders}
        open={openFittingOrderAddDialog}
        close={closeFittingOrderAddDialog}
      />
      {openViewDialog ? (
        <OrderView
          open={openViewDialog.open}
          close={closeViewDialog}
          item={openViewDialog.item}
        />
      ) : null}
      {openViewCompanyOrderDialog ? (
        <CompanyOrderView
          open={openViewCompanyOrderDialog.open}
          close={closeViewCompanyOrderDialog}
          item={openViewCompanyOrderDialog.item}
          orderType={"Prescription"}
        />
      ) : null}
      {openOrderDetailsModal ? (
        <OrderDetailsDialog
          open={openOrderDetailsModal}
          onClose={handleCloseOrderDetailsModal}
          onConfirm={openOrderDetailsModal.onPress}
          title={openOrderDetailsModal.title}
          msg={openOrderDetailsModal.msg}
          setOrderAdminDetails={setOrderAdminDetails}
          orderAdminDetails={orderAdminDetails}
        />
      ) : null}
      {openConfirmationModal ? (
        <ConfirmationDialog
          open={openConfirmationModal}
          onClose={handleCloseConfirmationModal}
          onConfirm={openConfirmationModal.onPress}
          title={openConfirmationModal.title}
          msg={openConfirmationModal.msg}
        />
      ) : null}
    </GridContainer>
  );
}
